module.exports = __webpack_public_path__ + "img/radish.af5cd54a.svg";